import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { AdminService } from '../services/admin.service';
import { ConstantsService } from '../services/constants.service';
import { DataService } from '../services/data.service';
import { UrlConstants } from '../services/url-constants';
import { environment } from "../../environments/environment"
import { Storage } from 'aws-amplify';
import { startWith } from 'rxjs/operators';
const REJECT_CACHE_KEY = 'rejectedCache'

@Component({
  selector: 'app-admin-rejected',
  templateUrl: './admin-rejected.component.html',
  styleUrls: ['./admin-rejected.component.scss']
})
export class AdminRejectedComponent implements OnInit {
  public isLoading = false;
  public currentUrl;
  public currentVideoTitle;
  public curentVideo;
  public currentIndex = 0;
  public videos;
  public disableEdit = true;
  public attributes = [];
  public videoName;
  public isDisable = false;
  public urlPrefix = `${environment.S3_URL_PRFIX}/${this.constants.REJECTED_TXT}`;

  skeltonArray;
  p: number = 1;
  videoTitle: any;
  constructor(
    public constants: ConstantsService,
    private adminservice: AdminService,
    private fb: UntypedFormBuilder,
    private dataService: DataService,
    private urlConstants: UrlConstants,
  ) {
    var skelton = [
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG
    ]
    this.skeltonArray = skelton;
   }

  ngOnInit(): void {
    this.isLoading = true;
    this.load();
  }
  onclickRow(video, event) {
    if (event.target.checked) {
      this.currentIndex = (this.videos.indexOf(video))
      this.currentUrl = video.url
      document.getElementById(`${video.videoName}-title`).style.fontWeight = "600"
      this.currentVideoTitle = video.videoTitle;
      this.curentVideo = video.videoName;
      this.attributes.push({
        "videoName": this.curentVideo,
        "commonKey": this.constants.VIDEO_COMMON_KEY,
      })
    }
    else {
      document.getElementById(`${video.videoName}-title`).style.fontWeight = "Normal"
      this.curentVideo = video.videoName;
      this.attributes = this.attributes.filter(data => data.videoName !== this.curentVideo)
    }
  }
  onClickSelectAll(event) {
    var firstIndex = (this.p * 5) - 5
    var lastIndex = (this.p * 5)
    var currentPage = this.videos.slice(firstIndex, lastIndex)
    this.attributes = [];
    if (event.target.checked) {
      for (let value of currentPage) {
        this.attributes.push({
          "videoName": value.videoName,
          "commonKey": this.constants.VIDEO_COMMON_KEY,
        })
        let selectedRow = document.getElementById(`${value.videoName}-select`) as HTMLInputElement;
        selectedRow.checked = true
      }
    }
    else {
      for (let value of currentPage) {
        let selectedRow = document.getElementById(`${value.videoName}-select`) as HTMLInputElement;
        selectedRow.checked = false
      }
      this.attributes = [];
    }
  }
  async onClickDeleteAll() {
    this.attributes = this.videos
    this.onClickDelete()
  }
  async onClickDelete() {
    this.isDisable = true;
    if (this.attributes.length === 0) {
      this.isDisable = false;
      document.getElementById("error-alert").style.display = "block"
      document.getElementById("error-message").innerHTML = "Please select at least a video"
      setTimeout(function () {
        document.getElementById("error-alert").style.display = 'none'
      }, 5000);
    }
    else {
      const postParams = [
        { param: '{actionName}', value: 'deleteAll' }
      ];
      const postdata = this.attributes;
      this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, postParams), postdata)
        .subscribe(() => {
          this.isDisable = false;
          this.load();
        })
    }
  }
  load = async () => {
    this.isLoading = true;
    let rejectedVideos
    const params = [
      { param: '{object}', value: this.constants.GET_LIST },
      { param: '{id1}', value: this.constants.STATUS_TXT.REJECTED_TXT },
      { param: '{id2}', value: this.constants.GET_LIST },
    ];
    rejectedVideos = await this.dataService.getData(this.urlConstants.getUri(this.urlConstants.getList, params))
    rejectedVideos.subscribe(async (data) => {
      this.isLoading = false;
      this.videos = data["Items"]
      if (data["Items"].length !== 0) {
        this.videos.forEach(element => {
          element.url = `${environment.S3_URL_PRFIX}/${element.videoStatus}/${element.videoName}`
        });
        this.currentUrl = this.videos[this.currentIndex].url
        this.currentVideoTitle = this.videos[this.currentIndex].videoTitle
        this.curentVideo = this.videos[this.currentIndex].videoName;
        this.isLoading = false
      }
      else {
        this.isLoading = false;
        this.currentUrl = '';
        this.currentVideoTitle = '';
        this.curentVideo = '';
      }
    })
  }
  closeErrorAlert() {
    document.getElementById("error-alert").style.display = this.constants.NONE_TXT
  }
  closeSuccessAlert() {
    document.getElementById("videoTitle").innerHTML = "";
    document.getElementById("success-alert").style.display = this.constants.NONE_TXT
  }
}
